export default __webpack_public_path__ + "images/assets/94158c406a28596a3ba650acc9618bf3.svg";